// Local (pre-login) offer draft for the public tarjouspyyntö preview page.
// Same philosophy as the wizard's quoteStorage: localStorage while anonymous,
// server draft once authenticated (the authenticated OfferForm hydrates from
// this and clears it after a successful save). _savedAt caps draft life at
// 48 h — the preview token's own lifetime.
import { safeLocalGet, safeLocalSet, safeLocalRemove } from "src/utils/storage";

const MAX_AGE_MS = 48 * 60 * 60 * 1000;
const key = (pumppuRequestId) => `betonijerry.offerDraft.${pumppuRequestId}`;

export function readOfferDraft(pumppuRequestId) {
    const d = safeLocalGet(key(pumppuRequestId));
    if (!d || typeof d !== "object") return null;
    if (typeof d._savedAt !== "number" || Date.now() - d._savedAt > MAX_AGE_MS) {
        safeLocalRemove(key(pumppuRequestId));
        return null;
    }
    return { price: d.price ?? "", extraNotes: d.extraNotes ?? "" };
}

export function writeOfferDraft(pumppuRequestId, { price, extraNotes }) {
    safeLocalSet(key(pumppuRequestId), { price, extraNotes, _savedAt: Date.now() });
}

export function clearOfferDraft(pumppuRequestId) {
    safeLocalRemove(key(pumppuRequestId));
}
